export enum CalibrationValidationStatus {
    Initialize = 1,
    Valid = 2,
    Invalid = 3
}
